import React from "react";

export default function ContinuingCalendarNote({ details }) {
  return (
    <div
      className="ContinuingCalendarNote has-bubble"
      data-cy={"ccn-" + details.name + "-" + details.current_day}
    >
      <div className="continuing-calendar-note-name small-heading-txtstyl">
        {details.name}
      </div>
      <div
        className={
          "continuing-calendar-note-day-of-day subscript-txtstyl " +
          details.color_type
        }
      >
        {"Day " + details.current_day + "/" + details.duration}
      </div>
    </div>
  );
}
